import BlockIcon from '@mui/icons-material/Block'
import DraftsIcon from '@mui/icons-material/Drafts'
import EmailIcon from '@mui/icons-material/Email'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead'
import MouseIcon from '@mui/icons-material/Mouse'
import ReportIcon from '@mui/icons-material/Report'
import ScheduleIcon from '@mui/icons-material/Schedule'
import SendIcon from '@mui/icons-material/Send'
import UnsubscribeIcon from '@mui/icons-material/Unsubscribe'

import type { EmailStatusConfig } from '../types/email.types'

export const getEmailStatusConfig = (status: string): EmailStatusConfig => {
  switch (status) {
    case 'delivered':
      return {
        icon: <MarkEmailReadIcon sx={{ fontSize: 16 }} />,
        color: 'success',
      }
    case 'open':
      return {
        icon: <DraftsIcon sx={{ fontSize: 16 }} />,
        color: 'success',
      }
    case 'click':
      return {
        icon: <MouseIcon sx={{ fontSize: 16 }} />,
        color: 'success',
      }
    case 'bounce':
      return {
        icon: <BlockIcon sx={{ fontSize: 16 }} />,
        color: 'error',
      }
    case 'dropped':
      return {
        icon: <ErrorOutlineIcon sx={{ fontSize: 16 }} />,
        color: 'error',
      }
    case 'spamreport':
      return {
        icon: <ReportIcon sx={{ fontSize: 16 }} />,
        color: 'error',
      }
    case 'scheduled':
      return {
        icon: <ScheduleIcon sx={{ fontSize: 16 }} />,
        color: 'warning',
      }
    case 'new':
      return {
        icon: <EmailIcon sx={{ fontSize: 16 }} />,
        color: 'warning',
      }
    case 'deferred':
      return {
        icon: <HourglassEmptyIcon sx={{ fontSize: 16 }} />,
        color: 'warning',
      }
    case 'processed':
      return {
        icon: <SendIcon sx={{ fontSize: 16 }} />,
        color: 'info',
      }
    case 'unsubscribe':
      return {
        icon: <UnsubscribeIcon sx={{ fontSize: 16 }} />,
        color: 'default',
      }
    default:
      return {
        icon: <EmailIcon sx={{ fontSize: 16 }} />,
        color: 'default',
      }
  }
}

export const formatEmailStatus = (status: string): string => {
  const statusMap: Record<string, string> = {
    scheduled: 'Scheduled',
    new: 'New',
    processed: 'Processed',
    dropped: 'Dropped',
    deferred: 'Deferred',
    bounce: 'Bounced',
    delivered: 'Delivered',
    open: 'Opened',
    click: 'Clicked',
    spamreport: 'Spam Report',
    unsubscribe: 'Unsubscribed',
  }
  return statusMap[status] || status
}
